import { render, staticRenderFns } from "./PartnerDirectory.vue?vue&type=template&id=e65f5390&scoped=true"
import script from "./PartnerDirectory.vue?vue&type=script&lang=js"
export * from "./PartnerDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65f5390",
  null
  
)

export default component.exports